import Vue from 'vue'
import axios from 'axios'

let Request = {
  // testBaseUrl: 'http://39.108.74.15:8820', // 接口URL地址
  baseUrl: process.env.NODE_ENV === 'development' ? 'http://192.168.0.92:8820' :  window.location.protocol + '//' + window.location.hostname + ':' + location.port , // 接口URL地址
  // baseUrl: 'http://192.168.0.64:8820',
  // baseUrl:'http://resultapi.fairplay.xin',
  Time: {
    timeout: 30000 // 请求30秒超时
  }

}


Vue.prototype.$imgUrl = Request.baseUrl
axios.defaults.baseURL = Request.baseUrl
function headersF()
{
  return {
    headers:{
      "Authorization":'Bearer '+localStorage.Token,
      "Content-Type":'application/json'
    }
  }
}


/*登入接口*/
export function login(data){
  let headers2 = {
    "Authorization":'Basic d2ViOnNlY3JldA==',
    "Content-Type":'application/x-www-form-urlencoded'
  }
  return axios.post(`/oauth/token`, (data), {headers:headers2})
}

// 添加运动会
export function addSportList (data) {

  return axios.post(`/admin/sportermeeting/backstage/add`,data, headersF(), Request.Time)
}
// 添加组别
export function addSort (data) {
  return axios.post(`/admin/sort/manual/add`,data, headersF(), Request.Time)
}
// 添加性别组
export function addSexsort (data) {


  return axios.post(`/admin/sexsort/manual/add`,data, headersF(), Request.Time)
}
// 获取组别列表
export function getSort (gameID) {
  return axios.get(`/admin/sort/list/${gameID}`, headersF(), Request.Time)
}
// 获取性别组别列表
export function getSexsortList(gameID) {
  return axios.get(`/admin/sexsort/list/${gameID}`, headersF(), Request.Time)
}
// 运动会列表
export function getSportList (pag) {

  return axios.post(`/admin/sportermeeting/list`,pag, headersF(), Request.Time)
}
//使用refresh_token刷新获取token
export function Uptoken(token) {
  let headers3 = {
    "Authorization": `Basic ${token}`,
    "Content-Type":'application/x-www-form-urlencoded'
  }
  return axios.post('/oauth/token',{headers:headers3}, Request.Time)
}

//获取所有项目
export function getEventList() {
  return axios.get('/admin/event/common/list', headersF())
}
//获取所有项目(打印证书)
export function getEventList2(id) {
  return axios.post('/admin/event/list/'+id,{}, headersF())
}
//获取运动会下面选中的项目
export function getEventListGameID(gameID) {
  return axios.get(`/admin/eventlist/selectByGameId/${gameID}`, headersF())
}

//添加项目
export function addEvent(data) {
  return axios.post('/admin/sexsortevent/manual/add',data, headersF())
}
//获取运动会项目
export function getEvent(gameID) {
  return axios.get(`/api/event/list/${gameID}`, headersF())
}
//获取运动会项目
export function sexsorteventlayer(gameID) {
  // return axios.get(`/api/sexsorteventlayer/filter/list/${gameID}`, headersF())
  return axios({
      url: `/api/sexsorteventlayer/filter/list/${gameID}`,
      method: 'get',
      headers: {
        "Authorization":'Bearer '+localStorage.Token,
        "Content-Type":'application/json'
      }
  });
}
//获取运动员
export function getSportsmanList(data) {
  return axios.post('/admin/sporter/third/like/querysporter',data, headersF())
}
//竞赛成绩录入
export function addManual(data) {
  return axios.post('/admin/runevent/manual/add',data, headersF())
}
//田远成绩录入
export function addfareventbest(data) {
  return axios.post('/admin/fareventbest/manual/add',data, headersF())
}
//田高成绩录入
export function addhigheventbest(data) {
  return axios.post('/admin/higheventbest/manual/add',data, headersF())
}
//接力成绩录入
export function addrelayevent(data) {
  return axios.post('/admin/relayevent/manual/add',data, headersF())
}
//全能成绩录入
export function addAlleventscore(data) {
  return axios.post('/admin/alleventscore/manual/add',data, headersF())
}
// 项目成绩列表
export function getGrade (query) {
  let grp = query.grp ? `&grp=${query.grp}` : ''
  return axios.get(`/admin/score/sexsortevent/list?property=${query.property}&sexSortEventID=${query.sexSortEventID}&layer=${query.layer}&allProp=${query.allProp}${grp}`,  headersF())
}
// 全能总成绩列表
export function getsexSortEvent (sexSortEventID) {
  return axios.get(`/api/alleventscore/list/${sexSortEventID}`, Request.Time)
}

//田高成绩参数设置
export function addHighincrease(data) {
  return axios.post('/admin/highincrease/manual/add',data, headersF())
}
//获取田高成绩参数
export function getHighincrease(data) {
  return axios.get(`/admin/highincrease/list/${data.sexSortEventID}/${data.layer}` ,headersF())
}
//接力棒次设置
export function addRelaycrease(data) {
  return axios.post('/admin/event/manual/add',data, headersF())
}
//获取接力棒次
export function getRelaycrease(data) {
  return axios.post('/admin/event/item',data, headersF())
}
//添加全能分项
export function addAllevent(data) {
  return axios.post('/admin/sexsortallevent/add/item',data, headersF())
}
//获取全能分项
export function getAllevent(sexsorteventID) {
  return axios.get(`/admin/sexsortallevent/list/${sexsorteventID}`, headersF())
}
//删除组别
export function delGroup(sortID) {
  return axios.post(`/admin/sort/manual/delete/${sortID}`,{}, headersF())
}
//删除组别性别
export function delGroupSex(sexSortID) {
  return axios.post(`/admin/sexsort/manual/delete/${sexSortID}`,{}, headersF())
}
// 删除全能成绩
export function delAllEvent(allEventScoreID) {
  return axios.post(`/admin/alleventscore/manual/delete/${allEventScoreID}`,{}, headersF())
}
// 批量删除全能成绩
export function delBatchAllEvent(allEventScoreID) {
  return axios.post(`/admin/alleventscore/manual/deleteBatch`,allEventScoreID, headersF())
}
// 删除田远成绩
export function delArEvent(farEventBestID) {
  return axios.post(`/admin/fareventbest/manual/delete/${farEventBestID}`,{}, headersF())
}

// 批量删除田远成绩
export function delBatchArEvent(farEventBestID) {
  return axios.post(`/admin/fareventbest/manual/deleteBatch`,farEventBestID, headersF())
}

// 删除田高成绩
export function delHighEvent(highEventBestID) {
  return axios.post(`/admin/higheventbest/manual/delete/${highEventBestID}`,{}, headersF())
}
// 批量删除田高成绩
export function delBatchHighEven(highEventBestID) {
  return axios.post(`/admin/higheventbest/manual/deleteBatch`,highEventBestID, headersF())
}
// 删除接力成绩
export function delRelayEvent(relayEventID) {
  return axios.post(`/admin/relayevent/manual/delete/${relayEventID}`,{}, headersF())
}
// 批量删除接力成绩
export function delBatchRelayEven(relayEventID) {
  return axios.post(`/admin/relayevent/manual/deleteBatch`,relayEventID, headersF())
}
// 删除竞赛成绩
export function delRunEvent(runEventID) {
  return axios.post(`/admin/runevent/manual/delete/${runEventID}`,{}, headersF())
}
// 批量删除竞赛成绩
export function delBatchRunEven(runEventID) {
  return axios.post(`/admin/runevent/manual/deleteBatch`,runEventID, headersF())
}
// 批量删除竞赛成绩
export function scoreAudit(obj) {
  return axios.post(`admin/audit/score`,obj, headersF())
}
// 查询用户和单位关系接口
export function getUserUnitList(userID) {
  return axios.get(`/admin/manual/user/getUserUnitList/${userID}`, headersF())
}
// 上传到历史库
export function internal(gameID) {
  return axios.get(`/admin/upload/internal/${gameID}`, headersF())
}

// 批量删除竞赛成绩
export function updateCurrPwd(data) {

  let headers = {
      "Authorization":'Bearer '+localStorage.Token,
      "Content-Type":'multipart/form-data'
  }
  return axios.post(`/admin/manual/user/updateCurrPwd`,data, headersF())
}

// 修改用户信息
export function updateCurrent(data) {
  return axios.post(`/admin/manual/user/updateCurrent`,data, headersF())
}

// 筛选运动会名称相同或者开始时间相似的运动会
export function findByGameNameOrBeginTime(data) {
  return axios.post(`/admin/sportermeeting/findByGameNameOrBeginTime`,data, headersF())
}

//获取用户信息
export function getInfo() {
  return axios.post(`/admin/manual/user/getInfo`,{}, headersF())
}

//更新录入状态
export function updatestate(data) {
  return axios.post(`/admin/sportermeeting/updatestate`,data, headersF())
}

//查看历史成绩
export function redirectToken() {
  return axios.post(`/admin/manual/user/redirectToken`, {},headersF())
}


//合并运动会
export function gameMerge(data) {
  return axios.post(`/admin/sportermeeting/gameMerge?fromGameID=${data.fromGameID}&toGameID=${data.toGameID}`, data,headersF())
}
// 赛事合并后的记录
export function sportermeetingmerge() {
  return axios.get(`/admin/sportermeetingmerge/all`, headersF())
}
//恢复合并的运动会
export function gamerollback(data) {
  return axios.post(`/admin/sportermeeting/gamerollback`, data,headersF())
}
//获取赛事未审核成绩数
export function countAuditInfo(data) {
  return axios.post(`/admin/sportermeeting/countAuditInfo`, data,headersF())
}

// 运动会列表
// export function getList (data) {
  
//   return axios.post(`/admin/sportermeeting/list`, data,headersF())
// }
// 搜索获奖证书
export function findPageBy (data) {
  return axios.post(`/admin/sporteraward/findPageBy`,data,headersF())
}
// 查看参赛单位列表
export function getCorporationList (id) {
  return axios.get(`/api/unit/list/${id}`, Request.Time)
}
// 获取基础信息
export function findQueryParame (gameId) {
  return axios.get(`/admin/sporteraward/findQueryParame/${gameId}`,headersF())
}

// 获取当前时间戳
export function currentTimes () {
  return axios.get(`/api/resources/currentTime`, Request.Time)
}
//重新生成奖状
export function createAward (data) {
  return axios.post(`/admin/awardprint/createAward`,data,headersF())
}

//导出全部奖状
export function downZip (parame) {
  return axios({
    method: 'get',
    url: `/admin/sporteraward/downZip?${parame}`,
    responseType:'blob',
    headers:{
      "Authorization":'Bearer '+localStorage.Token,
    }
  })

}





// WEBPACK FOOTER //
// ./src/lib/api/index.js